module.exports = __webpack_public_path__ + "img/EMT-BRCA_GSE176078.4428e1fd.png";